export enum Elo {
  MAGISTER = 'MAGISTER',
  SOMTODAY = 'SOMTODAY',
  SOMTODAY_CONNECT = 'SOMTODAY_CONNECT',
}

export enum EloDisplayValue {
  MAGISTER = 'Magister',
  SOMTODAY = 'Somtoday',
  SOMTODAY_CONNECT = 'Somtoday connect',
}

export interface HomiSettings {
  elo?: EloSettings;
  planning?: PlanningSettings;
  personId?: string;
}

export interface EloSettings {
  elo: Elo;
  isActive: boolean;
  linkUri?: string;
  activitiesAndTasksSyncLastSuccessfulAt?: string;
  gradesSyncLastSuccessfulAt?: string;
}

export interface PlanningSettings {
  showReflection: boolean;
  showTime: boolean;
  independent: boolean;
}

export interface EloSyncResults {
  activitiesAdded: number;
  activitiesRemoved: number;
  coursesAdded: number;
  coursesRemoved: number;
  gradesAdded: number;
  gradesRemoved: number;
  tasksAdded: number;
  tasksRemoved: number;
}
